/* eb-date.js — the theme's own date field.

   A native <input type="date"> is a good control with one flaw this shop cannot
   live with: every pixel of it is drawn by the browser, in the BROWSER's
   language. Its grey placeholder, its month names and its calendar popup follow
   the visitor's operating system, so a Chinese-language Mac reads 年/月/日 on a
   German storefront and there is no attribute that changes it. On a page whose
   whole argument is that the shop is careful, that is the one control that says
   otherwise.

   So the field is ours. The input is plain text holding an ISO date — the one
   format that is the same in every country and the one a merchant reading the
   registration wants — and the calendar beside it is built from the SHOP's
   language through Intl, not the visitor's.

   It is an upgrade, not a requirement. The markup ships complete: with this
   script removed the field is a text input with a pattern, a placeholder and
   required, and it submits the same value. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };

  function iso(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function parse(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((v || '').trim());
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    return d.getMonth() === +m[2] - 1 ? d : null;
  }

  [].slice.call(document.querySelectorAll('[data-eb-date]')).forEach(function (field) {
    var input = $('input', field);
    var pop = $('.eb-cal', field);
    var open = $('[data-eb-date-open]', field);
    if (!input || !pop || !open) return;

    /* The shop's language, not the visitor's: the page says what it is, and
       that is the language every other word on it is written in. */
    var lang = document.documentElement.lang || 'en';
    var monthFmt = new Intl.DateTimeFormat(lang, { month: 'long', year: 'numeric' });
    var dayFmt = new Intl.DateTimeFormat(lang, { weekday: 'short' });
    var fullFmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' });

    var min = parse(field.dataset.min);
    var max = parse(field.dataset.max);
    var view = parse(input.value) || max || new Date();
    view = new Date(view.getFullYear(), view.getMonth(), 1);

    /* Which day starts the week is a property of the LOCALE, not of the
       calendar: Monday across Europe, Sunday in the United States. */
    var firstDay = 1;
    try {
      var loc = new Intl.Locale(lang);
      var wi = loc.weekInfo || (loc.getWeekInfo && loc.getWeekInfo());
      if (wi && wi.firstDay) firstDay = wi.firstDay % 7;
    } catch (e) { /* keep Monday */ }

    function weekdays() {
      var out = '';
      for (var i = 0; i < 7; i++) {
        /* 2024-01-07 is a Sunday, so adding the offset lands on each weekday. */
        var d = new Date(2024, 0, 7 + ((firstDay + i) % 7));
        out += '<span>' + dayFmt.format(d).replace('.', '') + '</span>';
      }
      return out;
    }

    function draw() {
      var y = view.getFullYear(), m = view.getMonth();
      var start = new Date(y, m, 1);
      var lead = (start.getDay() - firstDay + 7) % 7;
      var days = new Date(y, m + 1, 0).getDate();
      var chosen = parse(input.value);
      var today = new Date(); today.setHours(0, 0, 0, 0);

      var cells = '';
      for (var i = 0; i < lead; i++) cells += '<span class="eb-cal__pad"></span>';
      for (var d = 1; d <= days; d++) {
        var date = new Date(y, m, d);
        var out = (min && date < min) || (max && date > max);
        var cls = 'eb-cal__day';
        if (chosen && +date === +chosen) cls += ' is-on';
        if (+date === +today) cls += ' is-today';
        cells += '<button type="button" class="' + cls + '" data-d="' + iso(date) + '"' +
          (out ? ' disabled' : '') + ' aria-label="' + fullFmt.format(date) + '"' +
          (chosen && +date === +chosen ? ' aria-current="date"' : '') + '>' + d + '</button>';
      }

      pop.innerHTML =
        '<div class="eb-cal__head">' +
          '<button type="button" class="eb-icon-btn" data-step="-1" aria-label="' + (pop.dataset.prev || 'Previous') + '">' +
            '<svg class="eb-icon eb-icon--sm" aria-hidden="true"><use href="#i-chevron-left"></use></svg></button>' +
          '<b>' + monthFmt.format(view) + '</b>' +
          '<button type="button" class="eb-icon-btn" data-step="1" aria-label="' + (pop.dataset.next || 'Next') + '">' +
            '<svg class="eb-icon eb-icon--sm" aria-hidden="true"><use href="#i-chevron-right"></use></svg></button>' +
        '</div>' +
        '<div class="eb-cal__week">' + weekdays() + '</div>' +
        '<div class="eb-cal__grid">' + cells + '</div>';
    }

    function show(on) {
      pop.hidden = !on;
      field.classList.toggle('is-open', on);
      open.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) draw();
    }

    open.addEventListener('click', function () { show(pop.hidden); });
    input.addEventListener('change', function () { if (!pop.hidden) draw(); });

    pop.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (step) {
        view = new Date(view.getFullYear(), view.getMonth() + (+step.dataset.step), 1);
        draw();
        return;
      }
      var day = e.target.closest('.eb-cal__day');
      if (!day || day.disabled) return;
      input.value = day.dataset.d;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      show(false);
      input.focus();
    });

    document.addEventListener('click', function (e) {
      if (!pop.hidden && !field.contains(e.target)) show(false);
    });
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) { show(false); open.focus(); }
    });
  });
}());
